import {
  ChangeDetectionStrategy,
  Component,
  inject,
  Input,
  OnInit,
} from '@angular/core';
import { EmptyComponent } from '@wilson/shared-components';
import { ClearTimelineFiltersButtonComponent } from '../timeline-filter/clear-timeline-filters-button/clear-timeline-filters-button.component';

import { TranslateModule } from '@ngx-translate/core';
import { ShiftTimelineFilterStateService } from '@wilson/shift-timeline/state';

@Component({
  selector: 'wilson-timeline-empty-filters-state',
  templateUrl: './timeline-empty-filters-state.component.html',
  styleUrls: ['./timeline-empty-filters-state.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    TranslateModule,
    EmptyComponent,
    ClearTimelineFiltersButtonComponent,
  ],
})
export class TimelineEmptyFilterStateComponent implements OnInit {
  @Input() isCollapsed = false;

  protected areTimelineFiltersSet = false;

  protected shiftTimelineFilterStateService = inject(
    ShiftTimelineFilterStateService,
  );

  ngOnInit(): void {
    this.areTimelineFiltersSet =
      this.shiftTimelineFilterStateService.areTimelineFiltersSet();
  }
}
